/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select } from 'antd';

const DATA_TYPES = ['String', 'Number', 'Date', 'Boolean'];

const ConvertDataTypeForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={{ targetType: 'String', ...config }} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Target Data Type" name="targetType" rules={[{ required: true }]}>
            <Select options={DATA_TYPES.map(t => ({ label: t, value: t }))} />
        </Form.Item>
    </Form>
);

export default ConvertDataTypeForm;
